import { useQuery } from '@tanstack/react-query'
import { Button } from '@/components/ui/button'
import { getJSON } from '@/lib/api'

interface AccountingSettingsResponse {
  accounting_settings: {
    connection: { status: 'connected' | 'disconnected' } | null
    sync_health?: {
      open_task_counts: { needs_mapping: number; drift: number; error: number }
    }
  }
}

export function AccountingSyncChip() {
  const settings = useQuery({
    queryKey: ['accounting-settings'],
    queryFn: () => getJSON<AccountingSettingsResponse>('/api/v1/accounting_settings'),
    retry: false,
  })
  const counts = settings.data?.accounting_settings?.sync_health?.open_task_counts
  const openItems = counts && counts.needs_mapping + counts.drift + counts.error
  const connected = settings.data?.accounting_settings?.connection?.status === 'connected'

  if (!connected || !openItems) return null

  return (
    <Button size="sm" variant="outline" asChild>
      <a href="/settings/accounting#accounting-tasks">
        QuickBooks · {openItems} open {openItems === 1 ? 'item' : 'items'} ›
      </a>
    </Button>
  )
}
